import { PropsWithChildren, useCallback, useEffect, useState } from 'react';
import {
  PanelsExpansionContext,
  panelsExpansionInitialState,
  PanelsExpansionState,
  SettingsPanelsNames,
} from './settingsPanel.context';
import { useContextSelector } from 'use-context-selector';

export const ExpandedPanelsContextProvider = ({ children }: PropsWithChildren) => {
  const [panelsExpansionState, setPanelsExpansionState] = useState<PanelsExpansionState>(panelsExpansionInitialState);

  return (
    <PanelsExpansionContext.Provider value={{ panelsExpansionState, setPanelsExpansionState }}>
      {children}
    </PanelsExpansionContext.Provider>
  );
};

export const usePanelState = (panelName: SettingsPanelsNames, initialState?: boolean) => {
  const { panelsExpansionState, setPanelsExpansionState } = useContextSelector(PanelsExpansionContext, (x) => x);

  useEffect(() => {
    if (!initialState) return;
    setPanelsExpansionState?.((prev) => ({
      ...prev,
      [panelName]: initialState,
    }));
  }, []);

  const handleExpand = useCallback(
    () =>
      setPanelsExpansionState?.((prev) => ({
        ...prev,
        [panelName]: !prev[panelName],
      })),
    [panelName, setPanelsExpansionState],
  );

  return {
    isExpanded: panelsExpansionState[panelName],
    toggleExpand: handleExpand,
  };
};
